module.exports = __webpack_public_path__ + "static/media/4.1_redux.png.8251fe76.png";